<template>
  <v-form>
    <v-layout row wrap>
      <v-flex xs12 class="scopes-panel">
        <token-manager v-model="jwt" :servicePermissions="servicePermissions" jwtType="API"/>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-subheader>Token expiry</v-subheader>
      </v-flex>
      <v-flex xs12 md8>
        <date-pick v-model="expiry" absolute="true"/>
      </v-flex>
      <v-flex xs12 v-if="error.date" class="date-error error--text text-xs-left">
        {{ error.date }}
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-subheader>Note</v-subheader>
      </v-flex>
      <v-flex xs12 md8>
        <v-text-field v-model="note"/>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-btn @click="goBack">Back</v-btn>
        <v-btn color="success" @click="createToken">Create</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="modal" width="750px">
      <v-card>
        <v-card-text>
          <template v-if="error.create">
            <div class="error--text">
              <ul>
                <li v-for="error in error.create">
                  <strong>{{ error }}</strong>
                </li>
              </ul>
            </div>
          </template>
          <template v-else-if="returnedToken === null">
            <p>Creating token...</p>
            <v-progress-circular indeterminate color="primary"/>
          </template>
          <template v-else>
            <p>Token successfully created</p>
            <p>JTI: {{ returnedJti }}</p>
            <p class="pre" @click="highlightToken" ref="tokenBody">
              {{ returnedToken }}
            </p>
            <v-btn @click="goBack">Close</v-btn>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
  import util from '@/util';
  import jwt from '@/lib/jwt';
  import TokenManager from '@/views/shared/jwtservices/TokenManager';
  import DatePick from '@/views/shared/DatePick';

  export default {
    components: { TokenManager, DatePick },
    data() {
      return {
        jwt: {},
        expiry: null,
        note: '',
        error: {
          date: null,
          create: null
        },
        modal: false,
        returnedToken: null
      };
    },
    computed: {
      returnedJti() {
        return this.returnedToken ? jwt.parse(this.returnedToken).jti : null;
      },
      servicePermissions() {
        return this.$store.state.auth.user.scopes.auth.servicePermissions;
      }
    },
    watch: {
      expiry(v) {
        if (v && new Date(v) < new Date()) {
          this.error.date = 'Selected date is in the past';
        } else {
          this.error.date = null;
        }
      },
      modal(v) {
        if (!v && this.returnedToken) {
          this.goBack();
        }
      }
    },
    methods: {
      goBack() {
        if (window.history.length > 1) {
          this.$router.go(-1);
        } else {
          this.$router.push('/tokens');
        }
      },
      createToken() {
        // if (!this.expiry) {
        //   this.error.date = 'You must specify an expiry date';
        //   return;
        // }
        this.$services.authenticator.post('/tokens', {
          granted: this.jwt,
          expiry: util.toUTCTimestamp(this.expiry),
          note: this.note
        })
          .then((res) => {
            this.returnedToken = res.data.data;
          }).catch((e) => {
            this.error.create =
              e.response && e.response.data && e.response.data.error
                ? e.response.data.error
                : 'Something went wrong';
            if (!(this.error.create instanceof Array)) {
              this.error.create = [this.error.create];
            }
          });
        this.modal = true;
      },
      highlightToken() {
        if (window.getSelection) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.$refs.tokenBody);
          selection.removeAllRanges();
          selection.addRange(range);
        } else if (document.body.createTextRange) {
          const range = document.body.createTextRange();
          range.moveToElementText(this.$refs.tokenBody);
          range.select();
        }
      }
    }
  };
</script>

<style scoped lang="less">
  @import '../../style/text.less';

  .scopes-panel {
    padding-bottom: 20px;
  }

  .date-error {
    padding-left: 30px;
  }
</style>
